import { createStore } from 'vuex'
import auth from '@/store/auth'

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
    isLoading: false,
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    setLoading(state, value) {
      state.isLoading = value
    },
  },
  actions: {},
  modules: {
    auth,
  },
})
